import { CONVENTIONAL } from 'helpers/globals'

const camera = {
  notes: '',
  imagerSize: 4.8,
  distance: 100,
  horizontalAngleOfView: 80,
  imagerCount: 1,
  horizontalResolution: 2688,
  verticalResolution: 1520,
  cameraHeight: 10,
  sceneHeight: 10,
  tilt: 0.00,
  fovMode: CONVENTIONAL,
  heading: 90,
  backgroundPosition: { backgroundPositionX: -229, backgroundPositionY: -30 },
  sceneName: 'Intersection',
  streetViewActive: false,
  userUploadedSceneActive: false,
  userSelectedGeneralScene: false,
  location: {},
  displayIrLine: true,
  ppfNightMode: 'infrared',
  userSelectedPpfNightMode: false,
  color: 'blue'
}

export const defaults = camera

export default _ => camera

const metricCamera = {
  ...camera,
  distance: 30,
  cameraHeight: 3,
  sceneHeight: 3
}

export const metricDefaults = metricCamera

export const coreCameraPropsMetric = _ => metricCamera



// WEBPACK FOOTER //
// ./src/helpers/cameras/coreCameraProps.js